export const programeducation = [
    {
        name: 'Step Up (3 - 6 tuổi)',
        link: '/course/step-up'
    },
    {
        name: 'Shining Statrs (6 - 11 tuổi)',
        link: '/course/shining-statrs'
    },
    {
        name: 'Teen Leaders (11 - 16 tuổi)',
        link: '/course/teen-leaders'
    },
    {
        name: 'English Communication',
        link: '/course/com/english-communication'
    },
]

export const centereducation = [
    {
        name: 'Trung tâm đào tạo',
        link: '/trung-tam-dao-tao'
    },
    {
        name: 'Lịch học',
        link: '/lich-hoc'
    },
]

export const contact = [
    {
        name: 'Đăng ký tư vấn',
        link: '/lien-he-tu-van'
    },
    {
        name: 'Tuyển dụng',
        link: '/dang-ki-tuyen-dung'
    },
]

export const login = [
    {
        name: 'Đăng nhập',
        link: '/login',
    },
    {
        name: 'Đăng kí',
        link: '/login',
    },
    {
        name: 'Tuyển dụng',
        link: '/dang-ki-tuyen-dung'
    }
]

